import moment from 'moment';

// Default display format (e.g. 9/9/2026 3:04 PM). Pass a `format` prop on the
// column config to override per-column.
const DEFAULT_FORMAT = 'M/D/YYYY h:mm A';

function DateTimeFormatter(props) {
	const { text, format = DEFAULT_FORMAT } = props;
	let date;

	if (typeof text === 'number') {
		// Unix timestamp (epoch)
		date = moment.unix(text);
	} else if (/^\d{8}$/.test(text)) {
		// Format: 20201213
		date = moment(text, 'YYYYMMDD');
	} else {
		// Handle ISO, string dates, etc.
		date = moment(text);
	}

	// Check if date is valid
	const formattedString = date.isValid()
		? date.format(format)
		: text;

	return <span title={text}>{formattedString}</span>;
}

export default DateTimeFormatter;
